var AdapterType;
(function (AdapterType) {
    AdapterType["NetApi"] = "net";
    AdapterType["HttpClient"] = "http";
    AdapterType["WebSocketClient"] = "ws";
    AdapterType["MediaUploader"] = "mediaUploader";
    AdapterType["RtcApi"] = "rtc";
})(AdapterType || (AdapterType = {}));

export { AdapterType };
//# sourceMappingURL=types.js.map
